export const UUID_AND_NUMERIC_REGEXP =
  /[^/]*[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}[^/]*|\b\d+\b/gi;

export const UUID_REGEXP = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

export const EMAIL_REGEXP = /[^\s/@]+@[^\s/]+\.[a-zA-Z]{2,}/g;

export const LONG_STRING_REGEXP = /(?<=\/)[^/]{31,}/g;
